import {
    abbrNumberVisitsFilter,
    minVisitsAbbrFilter,
    percentageSignFilter,
    swNumberFilter,
    timeFilter,
} from "app/filters/ngFilters";
import biDailyIntervalConfig from "pro-features/components/Chart/src/configs/granularity/biDailyIntervalConfig";
import monthlyIntervalConfig from "pro-features/components/Chart/src/configs/granularity/monthlyIntervalConfig";
import weeklyIntervalConfig from "pro-features/components/Chart/src/configs/granularity/weeklyIntervalConfig";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import type { ValueOf } from "pro-features/types";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const CHART_NAME = "Folder Analysis";

export const granularityConfigs = {
    Daily: biDailyIntervalConfig,
    Weekly: weeklyIntervalConfig,
    Monthly: monthlyIntervalConfig,
};

const { DESKTOP, MOBILE, TOTAL } = devicesTypes;

type Metric = "Visits" | "TrafficShare" | "UniqueUsers" | "PagesViews" | "PagePerVisit" | "Duration" | "BounceRate";

type Tab = {
    icon: string;
    title: string;
    filter: [Function, number?];
    yAxisFilter?: Array<Function>;
    chartTitle: string;
    id: Metric;
    supportedWebSources: Array<ValueOf<typeof devicesTypes>>;
    displayCustomAnnotation?: boolean;
    invertChange?: boolean;
};

type TabsMeta = Record<Metric, Tab>;

export const tabsMeta: TabsMeta = {
    Visits: {
        icon: "visits",
        title: "folderanalysis.tabs.visits",
        filter: [minVisitsAbbrFilter],
        yAxisFilter: [abbrNumberVisitsFilter],
        chartTitle: "folderanalysis.tabs.chart.title.visits",
        id: "Visits",
        supportedWebSources: [DESKTOP, MOBILE, TOTAL],
    },
    TrafficShare: {
        icon: "chart-pie",
        title: "segments.group.analysis.tab.trafficshare.title",
        filter: [percentageSignFilter, 2],
        chartTitle: "segments.group.analysis.tab.trafficshare.chart.title",
        id: "TrafficShare",
        supportedWebSources: [DESKTOP, MOBILE, TOTAL],
    },
    UniqueUsers: {
        icon: "monthly-unique-visitors",
        title: "folderanalysis.tabs.unique",
        filter: [minVisitsAbbrFilter],
        chartTitle: "folderanalysis.chart.title.unique",
        id: "UniqueUsers",
        supportedWebSources: [DESKTOP, TOTAL],
        get displayCustomAnnotation() {
            const isTotalWebsource = proNavigator.getParams().webSource === devicesTypes.TOTAL;
            return isTotalWebsource;
        },
    },
    PagesViews: {
        icon: "impressions",
        title: "folderanalysis.tabs.pageviews",
        filter: [minVisitsAbbrFilter],
        yAxisFilter: [abbrNumberVisitsFilter],
        chartTitle: "folderanalysis.tabs.chart.title.pageviews",
        id: "PagesViews",
        supportedWebSources: [DESKTOP, devicesTypes.TOTAL],
    },
    PagePerVisit: {
        icon: "pages-per-visit",
        title: "folderanalysis.tabs.pagespervisit",
        filter: [swNumberFilter, 2], // elem 0 = filter, elem[1] = filter params
        chartTitle: "folderanalysis.tabs.chart.title.pagespervisit",
        id: "PagePerVisit",
        supportedWebSources: [DESKTOP, devicesTypes.TOTAL],
    },
    Duration: {
        icon: "avg-visit-duration",
        title: "folderanalysis.tabs.duration",
        filter: [timeFilter],
        chartTitle: "folderanalysis.tabs.chart.title.duration",
        id: "Duration",
        supportedWebSources: [DESKTOP, devicesTypes.TOTAL],
    },
    BounceRate: {
        icon: "bounce-rate-2",
        title: "folderanalysis.tabs.bounce",
        filter: [percentageSignFilter],
        invertChange: true,
        chartTitle: "folderanalysis.tabs.chart.title.bounce",
        id: "BounceRate",
        supportedWebSources: [DESKTOP, devicesTypes.TOTAL],
    },
};
